// GENERATED FILE, PLEASE DO NOT EDIT
export var ButtonMedium = 36;
export var DatePickerDateCellMedium = 36;
export var FieldMedium = 36;